import { ActionReducerMap } from "@ngrx/store";
import { CalculationState, initialCalculationState } from "./calculation-state";
import { calculationReducer } from "./calculation-reducer";

export interface AppState {
  calculation: CalculationState
  // Add other feature states here as your application grows
}

// Only interested in these properties for undo/redo:
export const diffPropsCalculationState = (c: CalculationState) => ({
  lines: c?.lines ?? [],
  hourRates: c?.hourRates ?? [],
  tail: c?.tail ?? [],
  meta: c?.meta
})

export const initialState: AppState = {
  calculation: initialCalculationState
  // Initialize other feature states here
};

export const reducers: ActionReducerMap<AppState> = {
  calculation: calculationReducer,
  // Add other feature reducers here as your application grows,
};